import React from 'react';
import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Program',
  'Department',
  'Location',
  'Manager',
  'Gender',
  'Employee',
  'Employment Status',
  'Employment Type',
];

const TrainingSummaryReport = () => {
  return (
    <CompositeReport filters={filters}>
      <Report name={t('reports.TRAINING_SUMMARY_REPORT')}
              url='/reports/training_summary'>
      </Report>
    </CompositeReport>
  );
};

export default TrainingSummaryReport;
